/**
 * SubCategoryColumn.js
 * Written by: Alex Kasemir
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import SubCategoryRow from 'containers/SubCategoryRow';

import event from 'utils/event';

import {
  SubCategoryColumnContainer,
  QuizKindHeader,
  QuizKind,
  LoadButton,
} from './SubCategoryColumn.styles';

const DEFAULT_SHOW_AMOUNT = 4;
const FULL_SHOW_AMOUNT = 100;

/**
 * View you submitted questions
 *
 */
export default class SubCategoryColumn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: DEFAULT_SHOW_AMOUNT,
    };
  }

  loadMore = () => {
    const { subcats, type } = this.props;

    const newAmount = this.state.show === DEFAULT_SHOW_AMOUNT
      ? FULL_SHOW_AMOUNT
      : DEFAULT_SHOW_AMOUNT;

    event(`load-more`, [
      `click`,
      `load-${type}-subcategories`,
      `${newAmount === FULL_SHOW_AMOUNT ? `more` : `less`}`,
      subcats[0].category_id,
    ]);

    this.setState({
      show: newAmount,
    });
  }

  render() {
    const { subcats, type } = this.props;
    const { show } = this.state;

    if (subcats.length === 0) {
      return null;
    }

    return (
      <SubCategoryColumnContainer>
        {
          type === `EMH`
            ? <QuizKindHeader>
              <QuizKind>
                easy
              </QuizKind>
              <QuizKind>
                medium
              </QuizKind>
              <QuizKind>
                hard
              </QuizKind>
            </QuizKindHeader>
            : <QuizKindHeader kind="S"><QuizKind> play now </QuizKind></QuizKindHeader>
        }

        {
          subcats.slice(0, show).map((subcat) => (
            <SubCategoryRow key={subcat.id} subcategory={subcat} />
          ),
          )
        }
        {
          subcats.length > DEFAULT_SHOW_AMOUNT
            ? <LoadButton onClick={this.loadMore} type="tertiary">
              {`SHOW ${show === DEFAULT_SHOW_AMOUNT ? `MORE` : `FEWER`} QUIZZES`}
            </LoadButton>
            : null
        }

      </SubCategoryColumnContainer>
    );
  }
}

SubCategoryColumn.propTypes = {
  subcats: PropTypes.array.isRequired,
  type: PropTypes.string,
};
